import Amplify, { API, graphqlOperation } from 'aws-amplify';
import aws_exports from '../aws-exports';
import {activityStatus, localesUnderscoreMap, recommendationModes} from '../constants/constants';
import {formatLocale_UpperCaseUnderscore} from "Services/locale";
import Timeout from 'await-timeout';
import {getUserData} from "Services/API";
import { getMockedSkillsDiagnosticData } from './__mocks__/StudentRecordService';
import { FEATURE_FLAGS } from '../constants/featureFlags';
import { createActivityQuery } from './SRSCreateAcitityQuery';
const request = require('superagent');
import { logSessionInfo } from '../services/logger';
import { GetBrandedAllowedCurriculums } from './BrandingService';
const DEVONLY_SINGLE_PHRASE_STORY = false;
Amplify.configure(aws_exports);

/***************************************************************************
*
* GRAPHQL QUERIES
*
****************************************************************************/
const GQL_PARENT_REPORT = `
query studentReport($studentId: String!, $equated: Boolean) {
  studentReport(studentId: $studentId, filter: {equatedScores: $equated}){
    parent{
      tips
      wcpm {
        score
        expected
      }
      AREA {
        score
        expected
      }
      vocabSize {
        score
        expected
      }
    }
  }
}`;

const GQL_DIAGNOSTIC_REPORT = `
query studentReport($studentId: String!){
  studentReport(studentId: $studentId){
    diagnosis{
      phon {
        id
        label
        score
        contents{
          name
          fields
        }
      }
      sight {
        id
        label
        score
        contents{
          name
          fields
        }
      }
      vocab {
        id
        label
        score
        contents{
          name
          fields
        }
      }
      decode {
        id
        label
        score
        contents{
          name
          fields
        }
      }
    }
  }
}`;

const GQL_ALL_REPORTS = `
query studentReport($studentId: String!){
  studentReport(studentId: $studentId){
    diagnosis{
      phon {
        id
        label
        contents{
          fields
        }
      }
      sight {
        id
        label
        contents{
          fields
        }
      }
      vocab {
        id
        label
        contents{
          fields
        }
      }
    }
  },
  diagnosis{
    phon {
      id
      label
      contents{
        fields
      }
    }
    sight {
      id
      label
      contents{
        fields
      }
    }
    vocab {
      id
      label
      contents{
        fields
      }
    }
  }
}`;

const GQL_OP_GETTAGS = `
query Activity($activityId: [String]!) {
  getActivity(activityId: $activityId) {
    tags
  }
}`;

// shallow query to fetch attributes of the child of an activity object
const GQL_OP_GETCHILD = `
query Activity($activityId: [String]!) {
  getActivity(activityId: $activityId) {
    children{
      activityId
      type
      status
    }
  }
}`;

const GQL_OP_GET_CHILD_ERRORS = `
query Activity($activityId: [String]!) {
  getActivity(activityId: $activityId) {
    children{
      activityId
      type
      status
      errors
    }
  }
}`;

const GQL_OP_GET_STATUS = `
query Activity($activityId: [String]!) {
  getActivity(activityId: $activityId) {
    status
    scores{
      wcpmScore
      equatedWCPM
    }
    scoreEstimates{
      ARM_estimate
    }
    errors
    flagging{
      triggered
    }
  }
}`;

const GQL_OP_ACTIVITY_ERRORS_BY_ID = `
query Activity($activityId: [String]!) {
  getActivity(activityId: $activityId) {
    errors
    flagging {
      triggered
    }
  }
}`;

// gets a complete story by id
const GQL_OP_STORY_BY_ID = `
query GetStory($storyId: String!,$locale: String) {
  getAmiraStoryById(storyid: $storyId) {
    storyid
    grade
    author
    title
    type,
    nonAudio,
    tags,
    referenceStoryId,
    referenceStoryPhrases,
    chapters(locale: $locale){
      phrases
      items{
        type
        assetURL
        videoURL
        imageURL
        writtenInstructions
        minPhraseTime
        timeoutInMS
        word
        targetGrapheme
        playFTUE
        canViewReferenceStory
        letterDisplay
        playComponentIntroductions
        questions{
          correct
          distractors
          feedbackMode
          readQuestion
          text
        }
        options {
          key
          imageUrl
        }
        interactions {
          ids
          prompt
          imageURL
          response
          noResponsePrompt
          textInput
          excerpts
          standardSet
          hints {
            prompt
            hint
          }
          standardMapping {
            standardSet
            standardId
            amiraSkillId
            description
            reason
          }
        }
        predictionQuestions{
          correct
          distractors
          text
        }
        introductions{
          textIntroductions{
            full
            short
          }
          verbalIntroductions{
            full
            short
          }
          imageURL
          type
        }
        instructions{
          verbalInstructions
          repeatable
          repeatVariation
          videoURL
          imageURL
          text
          word
          targetPhoneme
          type
          transition
          model
          example{
            originalWord
            targetWord
          }
        }
        wordPartToDelete
        version
        startingWord
      }
      overrides {
        phraseIndex
        wordIndex
        metadata {
          WORD
          PHON
          NPHON
          NSYL
          NLET
          CONC
          COGNATE {
            spanish
          }
          SIGHT
          AREA_AOA
          AREA_discrim
          IMG_URL
          VIDEO_URL
          RHYME
          GRAPHEMIC_BREAKDOWN
          DEFINITION{
            default
          }
          DEFINITION_VIDEO
          FUNFACTS_IMG_URL
          FUNFACTS_DESCRIPTION
          PHONEME_VIDEO_URL
          RIDDLE
          RIDDLE_ANSWER
          MORPHEME
          MORPHEME_MEANING
          MORPHEME_POSITION
          MORPHEME_ALTS
          NAME_MEANING
          NAME_PERSON
          NAME_NATIONALITY
          NAME_FLAG
          log_ngram_counts
        }
      }
    }
    questions {
      text
      distractors
      correct
    }
  }
}`;

// gets a list of stories
// for now this is being used in place of recommendations
const GET_STORIES = `
query Stories {
  stories {
    storyId
    title
    chapters {
      phrases
    }
  }
}`;

const RECOMMEND = `
  query storyRecommendationService(
    $studentID: String,
    $studentGrade: String!,
    $storyType: String!,
    $numStoriesToReturn: Int!,
    $storyID: String,
    $mode: RecommendationMode
    $locale: StoryLocale){
    storyRecommendationService  (filter: {
    studentID: $studentID
    studentGrade: $studentGrade
    storyType: $storyType
    numStoriesToReturn: $numStoriesToReturn
    storyID: $storyID
    mode: $mode
    locale: $locale
    }){
      storyid
      title
      tags
      AREA_85
      AREA_95
    }
  }`;

// returns a list of sparse activy objects
// to be used on teacher activities (student search) page
// eventually this will need to be integrated with SIS
const GQL_ACTIVITIES = `
query GetStory($limit: Int!) {
  activities(limit: $limit) {
    activityId
    studentId
    createdAt
    updatedAt
    score
    timeRead
    student {
      studentId
      lastName
      firstName
    }
    scores {
      areaScore
      esriScore
      phonAwareScore
      vocabSize
      wcpmScore
      equatedWCPM
    }
    status
  }
}`

const GQL_STUDENT_ACTIVITIES = `
query studentActivities($studentId: [String]!, $limit: Int, $activityType: [String]!, $status: [String], $equated: Boolean, $dateStart: String, $dateEnd: String, $displayStatus: [String]) {
  studentActivities(studentId: $studentId, limit: $limit, filter: {activityType: $activityType, status: $status, equatedScores: $equated, dateStart: $dateStart, dateEnd: $dateEnd, displayStatus: $displayStatus}) {
    activityId
    studentId
    assignmentId
    parentId
    children {
      activityId
      assignmentId
      parentId
      studentId
      type
      status
      displayStatus
      errors
      createdAt
      updatedAt
      tags
      story{
        tags
      }
      scoreEstimates {
      ARM_estimate
    }
      scores {
      areaScore
      esriScore
      phonAwareScore
      vocabSize
      wcpmScore
      equatedWCPM
      decodeScore
      armScore
    }
    }
    createdAt
    updatedAt
    timeRead
    score
    errors
    flagging {
      triggered
    }
    type
    scoreEstimates {
      ARM_estimate
    }
    student{
      studentId
      firstName
      lastName
    }
    scores {
      areaScore
      esriScore
      phonAwareScore
      vocabSize
      wcpmScore
      equatedWCPM
      decodeScore
      armScore
    }
    status
    tags
    displayStatus
    story {
      tags
      chapters {
        items {
          type
        }
      }
      grade
    }
  }
}`

const GQL_GET_TEST_METADATA = `
query studentActivities($studentId: [String]!, $limit: Int, $activityType: [String]!, $status: [String], $equated: Boolean) {
  studentActivities(studentId: $studentId, limit: $limit, filter: {activityType: $activityType, status: $status, equatedScores: $equated}) {
    activityId
    storyId
    createdAt
    updatedAt
    story{
      tags
    }
    status
    displayStatus
    tags
  }
}`

const GQL_PROGRESS_ACTIVITIES = `
query studentActivities($studentId: [String]!, $limit: Int, $activityType: [String]!, $status: [String], $equated: Boolean, $dateStart: String, $dateEnd: String) {
  studentActivities(studentId: $studentId, limit: $limit, filter: {activityType: $activityType, status: $status, equatedScores: $equated, dateStart: $dateStart, dateEnd: $dateEnd}) {
    activityId
    studentId
    story {
      title
      grade
      tags
    }
    createdAt
    updatedAt
    sessionTime
    score
    type
    errors
    tags
    displayStatus
    scores {
      areaScore
      esriScore
      phonAwareScore
      vocabSize
      wcpmScore
      equatedWCPM
      decodeScore
      armScore
      currentArmEstimate
    }
    scoreEstimates{
      ARM_estimate
    }
    children{
      type
      errors
      status
      displayStatus
      activityId
      scores {
        predWcpm
        armScore
      }
    }
    status
    comprehensionDialog {
      phraseIndex
    }
  }
}`

const GQL_CHECK_ASSIGNMENTS = `
query studentActivities($studentId: [String]!) {
  studentActivities(studentId: $studentId filter: {activityType: ["assessment","dyslexia","nwf","spelling","listeningComprehension","readingComprehension","vocabularyScreener"], status: ["assigned","scored","rescored","not_started","scoring","in_progress","underReview"]}, limit: 30) {
    activityId
    type
    status
    displayStatus
    createdAt
    parentId
    tags
    children{
      type
      activityId
      status
      displayStatus
      tags
    }
    story{
      tags
    }
  }
}`

const GQL_CHECK_SCORED = `
query studentActivities($studentId: [String]!) {
  studentActivities(studentId: $studentId filter: {activityType: ["assessment","tutor"], status: ["scored","rescored","not_started","scoring","in_progress","underReview"]}, limit: 30) {
    activityId
    storyId
    type
    status
    displayStatus
    tags
    children{
      type
      activityId
    }
  }
}`

const GQL_DYSLEXIA_ACTIVITIES = `
query studentActivities($studentId: [String]!, $limit: Int, $activityType: [String]!, $status: [String]) {
  studentActivities(studentId: $studentId, limit: $limit, filter: {activityType: $activityType, status: $status}) {
    activityId
    studentId
    createdAt
    status
    displayStatus
    tags
    scores{
      dyslexiaRiskCategory
      dyslexiaRiskIndicator
    }
  }
}`

const GQL_GET_STUDENT_TREND = `
query getStudentTrend($studentTrendInput: StudentTrendInput!) {
  getStudentTrend(studentTrendInput: $studentTrendInput) {
    studentId
    trend
  }
}`;

// updates the error list of an activity and changes its status to rescored
const UPDATE_ACTIVITY = `
mutation UpdateActivity($activityId: String!, $sessionTime: Int, $errors: [[Boolean]], $score: Int, $skips: [Int], $selfCorrections: [Int], $mispronunciations: [Int],$timeRead: Int, $status: String, $displayStatus: String, $storyId: String, $parentId: String, $displayStatus: String, $responses: [[String]],$tags: [ActivityTags]) {
  updateActivity(activityId: $activityId, sessionTime: $sessionTime, status: $status, displayStatus: $displayStatus, errors: $errors, score: $score, skips: $skips, selfCorrections: $selfCorrections, mispronunciations: $mispronunciations, timeRead: $timeRead, status: $status, storyId: $storyId, parentId: $parentId, displayStatus: $displayStatus, responses: $responses, tags: $tags) {
    activityId
    tags
  }
}`

const SCORE_TUTOR = `
mutation UpdateActivity($activityId: String!, $errors: [[Boolean]], $timeRead: Int, $status: String, $displayStatus: String, $interventionWords: [[Boolean]]) {
  updateActivity(activityId: $activityId, status: $status, displayStatus: $displayStatus, errors: $errors, timeRead: $timeRead, interventionWords: $interventionWords) {
    activityId
    tags
  }
}`

const UPDATE_FLAG = `
mutation updatePhraseFlag($activityId: String!, $phraseIndex: Int, $triggered: Boolean){
  process(activityId: $activityId, phraseIndex: $phraseIndex, triggered: $triggered){
    triggered
  }
}`

const INITIAL_SCORE = `
mutation UpdateActivity($activityId: String!, $errors: [[Boolean]]!, $score: Int) {
  updateActivity(activityId: $activityId, status: "scored", errors: $errors, score: $score) {
    activityId
  }
}`;

// creates an activity with a type, an SIS student id, and a story id
const CREATE_ACTIVITY = `
mutation PutActivity($type: String!, $studentId: String!, $storyId: String!, $status: String, $displayStatus: String,$districtId: String, $schoolId: String, $tags: [ActivityTags], $assignmentId: String) {
  putActivity(type: $type, studentId: $studentId, storyId: $storyId, status: $status, displayStatus: $displayStatus, districtId: $districtId, schoolId: $schoolId, tags: $tags, assignmentId: $assignmentId) {
    activityId
    type
    status
    storyId
    districtId
    schoolId
    tags
    assignmentId
  }
}`;

const GQL_GET_LICENSING =`
query getLicensing($districtId: Int!, $schoolId: Int!){
  getAmiraLicenses(districtId: $districtId, schoolId: $schoolId) {
    audioDisabledDistricts
    tutorEnabled
    tutorAssignmentEnabled
    assessmentEnabled
    assessmentPageNavEnabled
    autoAssign
    branding
    partner
    calibrationEnabled
    demoMode
    demoLockdown
    dyslexiaEnabled
    dyslexiaParentLetterEnabled
    dyslexiaTestEnabled
    parentReportEnabled
    enablePretest
    prereaderAudioEnabled
    formOverrides{
      dyslexia
      nwf
      spelling
      listeningComprehension
      readingComprehension
      assessment
      vocabularyScreener
    }
    locale
    letternameConfig
    listeningCompConfig
    readingCompConfig
    reportingLanguage
    vocabularyScreenerConfig
    letterNamingAndSoundsConfig
    resourceProviders
    schoolYearStartDate
    screenerEnabled
    screeningStartDate
    screeningEndDate
    siteUnderMaintenance
    spanishConfig
    spellingConfig
    tutorWhitelist
    nwfConfig
    sorConfig{
      enableERPictures
      enablePracticePictures
      enableGiveWord
      enableFandP
      enableDRA
      enableLexile
      enableExtendedColumns
      selectedStandard
      interventionFrequency
      customARMLevelMapping
    }
    texasResources
    useStruggleMonitor
    useLatestARM
    iesEnabled
    districtAdminBadgingEnabled
    expandedEarlyReaderEnabled
    badgingEnabled
    showBadNetworkResponse
    statePercentileCuts {
      state
      label
      cutscores {
        red
        yellow
        green
        blue
      }
    }
    voiceOverrides{
      locale
      override
    }
    windowDisabledByGrade
    curriculum {
      locale
      curriculumId
      displayName
    }
    fourCutlineCategoriesEnabled
  }
}`;

const GQL_SKILL_FRAGMENT = `
  fragment skill on Skill {
    skillId
    name
    level
    resources {
      example {
        content
        resourceId
      }
      reference {
        url
        resourceId
        provider
        branding
        resourceIcon
        label
      }
    }
  }
`;

const GQL_SKILLGROUP_FRAGMENT = `
  fragment skillGroup on SkillGroup {
    percentileRank,
    LikelyMastered {
      ...skill
    }
    AppropriatelyChallenging {
      ...skill
    }
    VeryChallenging {
      ...skill
    }
  }
`;

const GQL_GET_DIAGNOSTIC_SKILLS = `
  query Skill($studentId: String!, $locale: Locale) {
    getSkills(studentId: $studentId, locale: $locale) {
      decoding(limit: 3) {
        ...skillGroup
      }
      vocabulary(limit: 3) {
        ...skillGroup
      }
      phonologicalAwareness(limit: 3) {
        ...skillGroup
      }
      sightRecognition(limit: 3) {
        ...skillGroup
      }
    }
  }
  ${GQL_SKILLGROUP_FRAGMENT}
  ${GQL_SKILL_FRAGMENT}
`;



const ENTITY_EXPORTS =`
query entityReports($entityId: String!, $entityType: String!){
  entityReports(entityId: $entityId, entityType: $entityType){
    entityId
    createdAt
    entityType
    status
  }
}`

const REQUEST_ENTITY_CSV_EXPORT =`
mutation exportEntityReport($entityId: String!, $entityType: String!){
  exportEntityReport(entityId: $entityId, entityType: $entityType){
    entityId
    createdAt
    entityType
    status
  }
}`

/*const onUpdateActivity = `subscription OnUpdateActivity($activityId: String) {
  onUpdateActivity(activityId: $activityId) {
    errors
  }
}
`;*/

export const onUpdateActivity = `
subscription OnUpdateActivity($activityId: String) {
  onUpdateActivity(activityId: $activityId) {
    errors
  }
}
`;


const CREATE_TUTOR_JOB = `
mutation createNrt($activityId: String!) {
  createNrtJob(activityId: $activityId) {
    activityId
    currentPass
    passes {
      model
      asr
      featureBatchFormat
      featureExtractor
      languageCode
      pipeline
      qualityAlgorithm
      scalingOverride
      slicingConfig
    }
    state
    updatedAt
    updatedBy
  }
}`

const GQL_LIST_CURRICULUMS = `
query GetListCurriculums {
  listCurriculums {
    curriculumId
    displayName
    locale
  }
}`;

const GQL_SKILLS_STATUS = `
query SkillsStatus($domain: Domain!, $classId: ID!, $nextToken: String, $locale: Locale, $curriculumId: String) {
  skillsStatus(classId: $classId,domain: $domain, limit: 50, nextToken: $nextToken, locale: $locale, curriculumId:$curriculumId
    ) {
    pageInfo {
      nextToken
    }
    records {
      studentId
      studentName
      domain
      mastery {
        value
        pacing
        grade
        month
      }
      progression {
        skillId
        skillName
        mastery {
          value
          pacing
          grade
          month
        }
        subSkills {
          skillId
          skillName
					skillAREAScore {
						AREA
						grade
						period
            month
				  }
					mastery {
						value
						pacing
						grade
						month
					}
          standard
          url
          exposureCount
          errorCount
        }
      }
    }
  }
}`;

const GQL_STUDENT_READING_ROPE = `
query StudentReadingRopeReport($studentId:ID, $locale: Locale, $useARM:Boolean, $useLatestARM:Boolean) {
  readingRopeReport(studentId:$studentId,locale:$locale,filter:{armScore: $useARM, useLatestScore: $useLatestARM}) {
    mastery {
      value
      pacing
      meta {
        srcActivityId
        srcActivityType
        srcGrade
        srcScoreName
        srcScoreValue
        srcSeason
      }
    }
    threads {
      label
      mastery {
        pacing
        value
      }
      domains {
        label
        mastery {
          value
          pacing
        }
        ... on StudentReadingRopeDomain {
          skills {
            skillId
            skillName
          }
        }
      }
    }
  }
}`;

const GQL_BATCH_STUDENT_READING_ROPE = `
query BatchStudentReadingRopeReport($studentIds: [ID], $locale: Locale, $useARM:Boolean, $useLatestARM:Boolean) {
  batchReadingRopeReport(studentIds: $studentIds, locale: $locale, filter: {armScore: $useARM, useLatestScore: $useLatestARM}) {
    studentId
    threads {
      domains {
        label
        ... on StudentReadingRopeDomain {
          label
          mastery {
            value
          }
        }
      }
      label
      mastery {
        value
      }
    }
  }
}`;

const GQL_CLASS_READING_ROPE = `
query ClassReadingRopeReport($classId:ID, $locale: Locale) {
  readingRopeReport(classId:$classId, locale: $locale) {
    mastery {
      value
      pacing
    }
    threads {
      mastery {
        value
        pacing
      }
      label
      domains {
        label
        mastery {
          value
          pacing
        }
      }
    }
  }
}`;

const GQL_SKILLS_DIAGNOSTIC_REPORT = `
query SkillsDiagnostic($studentId: ID!, $locale: Locale, $curriculumId: String) {
  diagnostic(studentId:$studentId, locale:$locale, curriculumId:$curriculumId, limit: 10000) {
    records {
        domain
        mastery {
          value
          pacing
          grade
          month
        }
        progression {
            skillId
            skillName
            skillArea
            url
            sequence
            mastery {
                value
                pacing
                grade
                month
            }
            subSkills {
              skillId
              skillName
              skillArea
              standard
              url
              sequence
              mastery {
                  value
                  pacing
                  grade
                  month
              }
              exposureCount
              errorCount
              standard
              skillAREAScore {
                AREA
                grade
                period
                month
              }
            }
        }
    }
  }
}`;

const GQL_RESOURCES = `
query Resources($studentId: ID!, $skillId: ID!) {
  skillResources(studentId: $studentId, skillId: $skillId) {
    resources {
      branding
      label
      provider
      resourceIcon
      resourceId
      url
    }
  }
}`;

const GQL_STUDENT_METRICS = `
  query StudentMetrics($studentIds: [String!]!, $dateStart: String, $dateEnd: String) {
    studentMetrics(studentId: $studentIds, dateStart: $dateStart, dateEnd: $dateEnd, activityType: ["tutor"]) {
      timeRead {
        sum
      }
      sessionTime {
        sum
      }
      activityCount(status: ["scored", "rescored"], activityType: ["tutor"]) {
        total
      }
      incompleteActivityCount: activityCount(status: ["in_progress", "not_started"], activityType: ["tutor"]) {
        total
      }
    }
  }
`

const SET_COMPREHENSION_DIALOG_FEEDBACK = `
  mutation SetComprehensionDialogFeedback($input: ComprehensionDialogFeedbackInput!) {
    setComprehensionDialogFeedback(input: $input) {
      activityId
      questionId
      stage
      feedback
      updatedAt
    }
  }
`;

const SET_COMPREHENSION_DIALOG_SCORE = `
  mutation SetComprehensionDialogScore($input: ComprehensionDialogScoreInput!) {
    setComprehensionDialogScore(input: $input) {
      activityId
      phraseIndex
      scoreOverride
    }
  }
`;


/***************************************************************************
*
* JS FUNCTIONS
*
****************************************************************************/

export default {
  async getStudentReport(studentId) {
    const data = await API.graphql(graphqlOperation(GQL_DIAGNOSTIC_REPORT, { studentId }));
    return data;
  },
  async getParentReport(studentId, equated) {
    const data = await API.graphql(graphqlOperation(GQL_PARENT_REPORT, { studentId, equated }));
    return data;
  },
  async getDiagnosticReport(studentId, locale) {
    locale = formatLocale_UpperCaseUnderscore(locale);
    const data = await API.graphql(graphqlOperation(GQL_GET_DIAGNOSTIC_SKILLS,{studentId, locale}));
    console.log("getDiagnostic",data); //leave in for debugging
    return data.data;
  },
  async scoreActivity(activityId, errors, skips, selfCorrections, mispronunciations,timeRead) {
    const displayStatus = activityStatus.RESCORED;
    const status = activityStatus.RESCORED;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, { activityId, errors, skips, selfCorrections, mispronunciations,timeRead, displayStatus, status }));
    console.log('DATA:', data);
    return data;
  },
  async scoreTutoring(activityId,errors,timeRead,interventionWords){
    const status = activityStatus.SCORED;
    const displayStatus = activityStatus.COMPLETED;
    const data = await API.graphql(graphqlOperation(SCORE_TUTOR, {activityId,errors,timeRead,status,displayStatus,interventionWords}));
    console.log("scoreTutoring",data);
    return data;
  },
  async setParent(activityId,parentId){
    if(!activityId || !parentId) return null;

    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId,parentId}));
    return data;
  },
  async saveSessionTime(activityId, sessionTime){
    if(!activityId || !sessionTime) return null;

    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId, sessionTime}));
    return data;
  },
  async getChild(activityId,parentId){
    const data = await API.graphql(graphqlOperation(GQL_OP_GETCHILD, {activityId}));
    return data.data.getActivity[0].children;
  },
  async getChild(activityId,parentId){
    const data = await API.graphql(graphqlOperation(GQL_OP_GET_CHILD_ERRORS, {activityId}));
    return data.data.getActivity[0].children;
  },
  async startActivity(activityId,storyId){
    //Don't set the status here.
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId,storyId}));
    console.log(data);
    return data.data.updateActivity;
  },
  async markCompleted(activityId,displayStatus){
    let status = activityStatus.SCORING_NOT_STARTED;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId,status,displayStatus}));
    return data.data.updateActivity;
  },
  async markInprogress(activityId){
    let status = activityStatus.SCORING_IN_PROGRESS;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId,status}));
    return data.data.updateActivity;
  },
  async markAbortedKeepingAssignment(activityId,displayStatus=activityStatus.ABORTED){
    const existingTags = await this.getTags(activityId);
    let tags = [...new Set([...existingTags, "NO_QA", "NO_EDM", "NO_SCALING"])];
    let status = activityStatus.ASSIGNED;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId, displayStatus, status}));
    return data.data.updateActivity;
  },
  async markAborted(activityId,displayStatus=activityStatus.ABORTED){
    const existingTags = await this.getTags(activityId);
    let tags = [...new Set([...existingTags, "NO_QA", "NO_EDM", "NO_SCALING"])];
    let status = activityStatus.SCORING_NOT_STARTED;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId, displayStatus, status, displayStatus, tags}));
    return data.data.updateActivity;
  },
  async markArchived(activityId,displayStatus=activityStatus.ARCHIVED){
    let status = activityStatus.ARCHIVED;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId, status, displayStatus}));
    return data.data.updateActivity;
  },
  async updateStatus(activityId,displayStatus){
    if(!displayStatus) return Promise.reject(new Error("No display status provided to update"),{activityId,displayStatus});
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, {activityId, displayStatus}));
    return data.data.updateActivity;
  },
  async primaryScore(activityId, errors, score) {
    const data = await API.graphql(graphqlOperation(INITIAL_SCORE, { activityId, errors, score }));
    console.log('DATA:', data);
    return data;
  },
  async finalizeNonAudioActivity(activityId, errors, responses) {
    let displayStatus = activityStatus.COMPLETED;
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, { activityId, errors, responses, displayStatus }));
    console.log('DATA:', data);
    return data;
  },
  async saveTextResponses(activityId, responses) {
    const data = await API.graphql(graphqlOperation(UPDATE_ACTIVITY, { activityId, responses}));
    return data;
  },
  async activities(limit) {
    const data = await API.graphql(graphqlOperation(GQL_ACTIVITIES, { limit }));
    console.log('DATA:', data);
    return data.data.activities.filter((activity)=>{return activity && activity.scores && activity.scores.wcpmScore > 0});
  },
  async studentActivities(studentId, limit=1, activityType=["assessment","tutor"], status=["scored","rescored","assigned","not_started","in_progress","scoring"], equated = false, dateStart, dateEnd, displayStatus) {
    try{
      const data = await API.graphql(graphqlOperation(GQL_STUDENT_ACTIVITIES, { studentId, limit, activityType, status, equated, dateStart, dateEnd, displayStatus }));

      return data.data.studentActivities;
    }catch(err){
      console.log("Error Fetching one or more activities:",err.errors);
      return err.data.studentActivities;
    }
  },
  async getTestMetadata(studentId, limit=1, activityType=["assessment","tutor"], status=["scored","rescored","assigned","not_started","in_progress","scoring"], equated = false) {
    const data = await API.graphql(graphqlOperation(GQL_GET_TEST_METADATA, { studentId, limit, activityType, status, equated }));
    return data.data.studentActivities;
  },
  async progressActivities(studentId, limit=1, activityType=["assessment","tutor"], equated = false, isARM = false, dateStart, dateEnd) {
    let status = ["scored","rescored","inProgress","underReview","scoring","reassess"];
    if (isARM) {
      // Include not_started activities when ARM is selected
      status.push("not_started");
    }
    let data = {};
    try{
      data = await API.graphql(graphqlOperation(GQL_PROGRESS_ACTIVITIES, { studentId, limit, activityType, status, equated, dateStart, dateEnd }));
    }catch(err){
      console.log('ERROR - while fetching progress activities: ',err);
      data = err;
    }

    //Put the arm estimate into the scores key of the activity so all null checks on tables/etc throughout the reporting don't have to add the scoreEstimates key
    if (data && data.data && data.data.studentActivities) {
      data.data.studentActivities.forEach(activity => {
          if (activity.scoreEstimates && activity.scores) {
              activity.scores.currentArmEstimate = activity.scoreEstimates.ARM_estimate;
          }
      });
    }
    return data.data.studentActivities;

  },
  async dyslexiaActivities(studentId, limit=1, status=["scored","rescored","underReview"]) {
    let activityType = 'dyslexia';
    const data = await API.graphql(graphqlOperation(GQL_DYSLEXIA_ACTIVITIES, { studentId, limit, activityType, status }));
    return data.data.studentActivities;
  },
  async getStudentTrend(students, date, language) {
    const studentTrendInput = { students, date, language };
    const data = await API.graphql(graphqlOperation(GQL_GET_STUDENT_TREND, { studentTrendInput }));
    return data.data.getStudentTrend;
  },
  async getAssignedStory(studentId, activityType = ["assessment","dyslexia","nwf","spelling","listeningComprehension"], limit = 1){
    const status = [activityStatus.ASSIGNED];
    const data = await API.graphql(graphqlOperation(GQL_STUDENT_ACTIVITIES, { studentId, limit, activityType, status }));
    console.log("getAssigned:", data);
    return data.data.studentActivities;
  },
  async checkForAssignments(studentId){
    try {
      const data = await API.graphql(graphqlOperation(GQL_CHECK_ASSIGNMENTS, {studentId}));
      console.log("checkAssigned:", data);
      return data.data.studentActivities;
    }catch(err){
      console.log("Error fetching one or more activities:",err.errors);
      return err.data.studentActivities;
    }
  },
  async checkForCompletedActivities(studentId){
    const data = await API.graphql(graphqlOperation(GQL_CHECK_SCORED, {studentId}));
    console.log("checkCompleted:", data);
    return data.data.studentActivities;
  },
  async getActivity(singleActivityId, excludeAudio = false) {
    let activityId = [];
    activityId.push(singleActivityId);
    const data = await API.graphql(graphqlOperation(createActivityQuery(excludeAudio), { activityIds: activityId }));
    console.log('DATA:', data);
    return data;
  },
  async getTags(singleActivityId){
    let activityId = [];
    activityId.push(singleActivityId);
    const data = await API.graphql(graphqlOperation(GQL_OP_GETTAGS, { activityId }));
    return data.data.getActivity[0].tags;
  },
  async getErrors(singleActivityId) {
    let activityId = [];
    activityId.push(singleActivityId);
    const data = await API.graphql(graphqlOperation(GQL_OP_ACTIVITY_ERRORS_BY_ID, { activityId }));
    console.log('Errors:', data);
    return data;
  },
  async getStory(storyId, locale = "en-us", retries = 2, backoff = 250) {

    // TODO: We can start writing more transformers, in a better spot, could help increase readability in places here
    // This transformer helps obfusicate some unecessary / unfavorably shaped data from the ingester.
    const transformComprehensionDialogData = (data) => {
      const userStandardSet = getUserData().sorConfig.selectedStandard;

      let foundIntroductionOverride = false;
      data.data.getAmiraStoryById.chapters = data.data.getAmiraStoryById.chapters.map(chapter => ({
        ...chapter,
        items: chapter.items.map(item => {
          if (item.type !== "interactive") {
            return item;
          }

          // The user should only see dialogs for their configured standard set, but the api gives all possible dialogs for this phrase and story
          // Filter the interactions array to include only those interactions
          // where at least one standardMapping has a standardSet matching userStandardSet.
          let filteredInteractions = item.interactions.filter(interaction =>
            interaction.standardMapping &&
            interaction.standardMapping.some(mapping => mapping.standardSet === userStandardSet)
          );
          console.log(`Comprehension Dialog: Found ${filteredInteractions.length} interactions for standard set '${userStandardSet}`);
          logSessionInfo('comprehension_dialogs_filtered', { filtered: filteredInteractions.map(i => i.ids[0]) });

          // This will only occur for the first interactive item.
          // The embedded introductions will be used for the start of the story introductions
          if (filteredInteractions.length && !foundIntroductionOverride && item.introductions) {
            chapter.items[0].introductions = item.introductions;
            delete item.introductions;
            foundIntroductionOverride = true;
          }

          // Transformations per interaction
          filteredInteractions = filteredInteractions.map(interaction => {
            const newInteraction = JSON.parse(JSON.stringify(interaction));
            // Parse the excerpts phrases from the indices sent.
            newInteraction.excerpts = interaction.excerpts.map(excerpt => data.data.getAmiraStoryById.chapters[0].phrases[excerpt]);

            return newInteraction;
          });

          return {
            ...item,
            interactions: filteredInteractions
          }
        })
      }));

      if (DEVONLY_SINGLE_PHRASE_STORY && process.env.stack !== 'PRODUCTION') {
        const short = data.data.getAmiraStoryById.chapters[0]
        // Shorten story
        short.phrases = short.phrases.map((p) =>  p.split(' ')[0] + ' ' + p.split(' ')[1])
        short.phrases = [
            short.phrases[0],
            short.phrases[1],
        ];
        short.items = [
            short.items[0],
            short.items[short.items.length - 1],
        ];
        // Shorten dialog
        if (short.items[short.items.length - 1].type === 'interactive') {
          // short.items[short.items.length - 1].interactions[0].prompt = 'Make it so';
          // short.items[short.items.length - 1].interactions[0].response = 'Make it just so';
          // short.items[short.items.length - 1].interactions[0].textInput = true;
        }
        if (short.items[0].introductions && short.items[0].introductions.verbalIntroductions && short.items[0].introductions.verbalIntroductions.full) {
          short.items[0].introductions.verbalIntroductions.full = "<speak>Skipping full intro.</speak>";
          short.items[0].introductions.verbalIntroductions.short = "<speak>Skipping short intro.</speak>";
        }
        console.log('%cShort story', '', storyId,locale,data);
        data.data.getAmiraStoryById.chapters = [short];
      }

      return data;
    }

    try {
      const request = graphqlOperation(GQL_OP_STORY_BY_ID, { storyId, locale });
      const data = await API.graphql(request);
      if (data.errors) {
        throw new Error(data.errors[0].message);
      }
      data.data.getAmiraStoryById.storyId = data.data.getAmiraStoryById.storyid;
      console.log('GetStory:', storyId,locale,data);
      const transformedData = transformComprehensionDialogData(data);

      return transformedData.data.getAmiraStoryById;
    } catch (err) {
      logSessionInfo('error_getting_story_by_id', { error: err, retriesRemaining: retries, request });
      console.log(`Error getting story by id.  Retries Remaining: ${retries}`, err);
      if (retries) {
        await new Promise(resolve => setTimeout(resolve, backoff));
        return this.getStory(storyId, locale, retries-1, backoff+250);
      } else {
        throw err;
      }
    }
  },
  async getStories() {
    const data = await API.graphql(graphqlOperation(GET_STORIES, { }));
    console.log('DATA:', data);
    return data;
  },
  async getRecommendedStories(studentID,studentGrade,storyType,numStoriesToReturn,storyID="",mode,locale){
    let query;
    try {
      //TODO: start passing locale all the way back to the back end when the dependency is ready
      if(!mode){
        mode = recommendationModes.SEQUENCE_EXPIRES;
      }
      locale = formatLocale_UpperCaseUnderscore(locale);
      query = graphqlOperation(RECOMMEND,{studentID,studentGrade,storyType,numStoriesToReturn,storyID,mode,locale});
      const data = await API.graphql(query);
      return data.data.storyRecommendationService.map((story)=>{
        story.storyId = story.storyid;
        return story;
      });
    } catch (err) {
      logSessionInfo('error_in_recommend_query', { error: err, query });
      throw err;
    }
  },
  async createActivity(type, studentId, storyId, status=activityStatus.SCORING_NOT_STARTED, callback=null,displayStatus,districtId=null,schoolId=null, tags=[], assignmentId=null) {
    try{
      let data = await API.graphql(graphqlOperation(CREATE_ACTIVITY, { type, studentId, storyId, status, displayStatus,districtId,schoolId,tags,assignmentId }));
      console.log('createActivity:', data);
      return data;
    }catch(err){
      if(callback){
        callback();
      }
      console.error("Failed to Create Activity. Activity will not be saved. ", err);
    }
  },
  async getEntitlements(districtId,schoolId){
    const data = await API.graphql(graphqlOperation(GQL_GET_LICENSING, {districtId,schoolId}));
    console.log("getEntitlements",data.data.getAmiraLicenses);
    return data.data.getAmiraLicenses;
  },
  async requestCSVExport(entityId,entityType){
    const data = await API.graphql(graphqlOperation(REQUEST_ENTITY_CSV_EXPORT, {entityId,entityType}));
    return data;
  },
  async getEntityReports(entityId,entityType){
    const data = await API.graphql(graphqlOperation(ENTITY_EXPORTS, {entityId,entityType}));
    return data;
  },
  async subscribeToErrorUpdates(activityId,callback=null){
    const subscription = await API.graphql(
      graphqlOperation(onUpdateActivity,{activityId: activityId})
    )

    subscription.subscribe({
      next: (resp) => {
        console.log("SUBSCRIPTION",Date.now(),resp,subscription); //TODO: Remove once happy with error detection
        if(resp && resp.value.data && resp.value.data.onUpdateActivity && resp.value.data.onUpdateActivity.errors){
          callback(resp.value.data.onUpdateActivity.errors);
        }else{
          callback(null);
        }
      },
      error: (err) => console.log(err)
    });
  },
  async updateFlaggedPhrase(activityId,phraseIndex,triggered){
    const data = await API.graphql(graphqlOperation(UPDATE_FLAG, {activityId, phraseIndex, triggered}));
    return data;
  },
  async createEPSJob(activityId) {
    const payload = {query: CREATE_TUTOR_JOB, variables: {activityId: activityId}};
    const resp = await request.post(process.env.EPS_BASE_URL)
        .set('x-api-key', process.env.EPS_API_KEY)
        .set('Content-Type', 'application/json')
        .send(payload);
    const { body } = resp;

    if (body.errors) {
      console.log(body.errors)
      throw new Error(body.errors[0].message);
    }
    return body.data;
  },
  async listCurriculums() {
    const query = GQL_LIST_CURRICULUMS;
    const { body } = await request.post(process.env.SKILLS_ENDPOINT_URL)
        .set('x-api-key', process.env.SKILLS_API_KEY)
        .set('Content-Type', 'application/json')
        .send({query});
    if (body.errors) {
      console.log(body.errors);
      throw new Error(body.errors[0].message);
    }
    const brandedAllowedCurriculums = GetBrandedAllowedCurriculums();
    body.data.listCurriculums = body.data.listCurriculums?.filter(c => brandedAllowedCurriculums.includes(c.curriculumId));
    return body.data;
  },
  async getSkillsStatusData({ classId, domain, nextToken="", locale, selectedCurriculum }) {
    const formattedLocale = locale && locale.includes("-") ? localesUnderscoreMap[locale] : locale;
    const query = GQL_SKILLS_STATUS
    const variables = { classId, domain, nextToken, locale: formattedLocale, curriculumId: selectedCurriculum };
    const payload = {query, variables}
    const {body} = await request.post(process.env.SKILLS_ENDPOINT_URL)
    .set('x-api-key', process.env.SKILLS_API_KEY)
    .set('Content-Type','application/json')
    .send(payload)

  if (body.errors) {
    console.log(body.errors)
    throw new Error(body.errors[0].message);
  }
  return body.data;
  },
  async getSkillsDiagnosticData(studentId, locale, curriculumId) {
    const mockData = getMockedSkillsDiagnosticData(studentId);
    if(FEATURE_FLAGS.MOCK_ERSS_SKILLS_DIAGNOSTIC && mockData) {
      return mockData.data;
    }

    const formattedLocale = locale && locale.includes("-") ? localesUnderscoreMap[locale] : locale;
    const query = GQL_SKILLS_DIAGNOSTIC_REPORT
    const variables = {studentId, locale: formattedLocale, curriculumId}
    const payload = {query, variables}
    const {body} = await request.post(process.env.SKILLS_ENDPOINT_URL)
      .set('x-api-key', process.env.SKILLS_API_KEY)
      .set('Content-Type','application/json')
      .send(payload)

    if (body.errors) {
      console.log(body.errors)
      throw new Error(body.errors[0].message);
    }
    return body.data;
  },
  async getReadingRopeData({ classId, studentId, studentIds, useARM = false, locale }) {
    const formattedLocale = locale && locale.includes("-") ? localesUnderscoreMap[locale] : locale;
    const {useLatestARM} = getUserData();
    let query;
    let variables;
    if (classId) {
      query = GQL_CLASS_READING_ROPE
      variables = {classId, locale: formattedLocale}
    }
    if (studentId) {
      query = GQL_STUDENT_READING_ROPE
      variables = {studentId,useARM,useLatestARM,locale: formattedLocale}
    }
    if (studentIds) {
      query = GQL_BATCH_STUDENT_READING_ROPE
      variables = {studentIds, useARM, useLatestARM, locale: formattedLocale}
    }
    const payload = {query, variables}
    const {body} = await request.post(process.env.SKILLS_ENDPOINT_URL)
    .set('x-api-key', process.env.SKILLS_API_KEY)
    .set('Content-Type','application/json')
    .send(payload)

  if (body.errors) {
    console.log(body.errors)
    throw new Error(body.errors[0].message);
  }
  return body.data;
  },
  async getResources(skillId,studentId) {
    const query = GQL_RESOURCES
    const variables = {skillId,studentId}
    const payload = {query, variables}
    const {body} = await request.post(process.env.SKILLS_ENDPOINT_URL)
      .set('x-api-key', process.env.SKILLS_API_KEY)
      .set('Content-Type','application/json')
      .send(payload)
    if (body.errors) {
      console.log(body.errors)
      throw new Error(body.errors[0].message);
    }
    return body.data;
  },
  async getActivityStatusAndScores(singleActivityId) {
    let activityId = [];
    activityId.push(singleActivityId);
    const data = await API.graphql(graphqlOperation(GQL_OP_GET_STATUS, { activityId }));
    console.log('getStatus:', data);
    return data.data.getActivity[0];
  },
  async waitUntilScored(activityId,timeout){
    if(timeout > 0){
      let activity = await this.getActivityStatusAndScores(activityId);
      if(activity.status === 'scored'){
        return activity;
      }else{
        const sleepTimer = new Timeout();
        await sleepTimer.set(1000);
        return await this.waitUntilScored(activityId,timeout-1000);
      }
    }else{
      return null;
    }
  },
  /**
   * fetches student metrics
   * @param {[string]} studentIds
   * @param {string} dateStart YYYY-MM-DD, inclusive
   * @param {string} dateEnd YYYY-MM-DD, inclusive
   * @returns
   */
  async getStudentMetrics(studentIds, dateStart, dateEnd) {
    //Account for the fact that dateEnd isn't inclusive. This is convoluted to be sure becasue we want to use UTC dates
    let utcDateEnd = dateEnd.split('-');
    let adjustedDate = new Date(Date.UTC(utcDateEnd[0], utcDateEnd[1]-1, utcDateEnd[2]));
    adjustedDate.setDate(adjustedDate.getDate() + 1);
    dateEnd = adjustedDate.toISOString().split('T')[0];

    const response = await API.graphql(graphqlOperation(GQL_STUDENT_METRICS, {studentIds, dateStart, dateEnd}))
    return response.data.studentMetrics
  },
  async setComprehensionDialogFeedback(activityId, questionId, stage, feedback) {
    const data = await API.graphql(graphqlOperation(SET_COMPREHENSION_DIALOG_FEEDBACK, { input: {activityId, questionId, stage, feedback} }));
    console.log('setComprehensionDialogFeedback',data);
    return data.data.setComprehensionDialogFeedback;
  },
  async setComprehensionDialogScore(activityId, phraseIndex, newScore) {
    const data = await API.graphql(graphqlOperation(SET_COMPREHENSION_DIALOG_SCORE, { input: {activityId, phraseIndex, score: newScore}}));
    console.log('setComprehensionDialogScore', data);
    return data.data.setComprehensionDialogScore;
  }
};